"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvironmentManager = void 0;
/**
 * A generic class to manage and track the current environment in an application.
 * This class allows setting and retrieving the current environment, ensuring type safety
 * by restricting the allowed environments to a specific set of string values.
 *
 * @template AllowedEnvironments - A union of string literals representing the allowed environments.
 * For example, `'development' | 'production' | 'staging'`.
 */
class EnvironmentManager {
    /**
     * Creates an instance of `EnvironmentManager`.
     *
     * @param initialEnv - The initial environment to set. Must be one of the allowed environments
     * defined by the `AllowedEnvironments` type.
     */
    constructor(initialEnv) {
        this.currentEnv = initialEnv;
    }
    /**
     * Updates the current environment to a new value.
     *
     * @param env - The new environment to set. Must be one of the allowed environments
     * defined by the `AllowedEnvironments` type.
     */
    setCurrentEnv(env) {
        this.currentEnv = env;
    }
    /**
     * Retrieves the current environment.
     *
     * @returns The current environment, which is one of the allowed environments
     * defined by the `AllowedEnvironments` type.
     */
    getCurrentEnv() {
        return this.currentEnv;
    }
}
exports.EnvironmentManager = EnvironmentManager;
//# sourceMappingURL=environmentManager.js.map